import type { FC } from 'react';
import type { IAlternativeCasino } from 'content/data';
import { Card, CardBody, CardFooter, Divider, Flex, Text } from '@chakra-ui/react';
import { LinkButton, List } from '@anywayseo/tools';

const AlternativeCasinoCard: FC<IAlternativeCasino> = ({ id, image, header, features, link }) => {
  return (
    <Card key={id} flex={1} variant='outline' height='100%'>
      <CardBody>
        <Flex mb={2}>{image}</Flex>
        <Text fontWeight='semibold'>{header}</Text>
        <Divider my={2} />
        <List items={features} bullet='' ms={-1} />
      </CardBody>
      <CardFooter pt={0}>
        <LinkButton {...link} width='full' />
      </CardFooter>
    </Card>
  );
};

export default AlternativeCasinoCard;
